import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { AccountType } from 'types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Spinner } from 'lp-components'
import { selectors as memberSelectors } from 'member-reducer'
import * as apiActions from 'api-actions'

const propTypes = {
  account: AccountType,
  applicationAccountId: PropTypes.string,
  applicationContactId: PropTypes.string,
  applicationMembershipId: PropTypes.string,
  children: PropTypes.node.isRequired,
  fetchMembershipApplicationAccount: PropTypes.func.isRequired,
}

function NewMemberApplicationAccountProvider({
  account,
  applicationAccountId,
  applicationContactId,
  applicationMembershipId,
  children,
  fetchMembershipApplicationAccount,
}) {
  const hasStoredApplicationIds = !!(
    applicationAccountId &&
    applicationContactId &&
    applicationMembershipId
  )

  useEffect(() => {
    if (hasStoredApplicationIds)
      fetchMembershipApplicationAccount({
        accountId: applicationAccountId,
        contactId: applicationContactId,
        membershipId: applicationMembershipId,
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationAccountId, applicationContactId, applicationMembershipId])

  // If Account exists then Contact and Membership (not checked for here) should also exist
  if (hasStoredApplicationIds && !account) return <Spinner />

  return children
}

NewMemberApplicationAccountProvider.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: memberSelectors.account(state),
    applicationAccountId: memberSelectors.applicationAccountId(state),
    applicationContactId: memberSelectors.applicationContactId(state),
    applicationMembershipId: memberSelectors.applicationMembershipId(state),
  }
}

const mapDispatchToProps = {
  fetchMembershipApplicationAccount:
    apiActions.fetchMembershipApplicationAccount,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  NewMemberApplicationAccountProvider,
)
